import './styling.scss';
import * as template from './template.html';

import * as angular from 'angular';
import * as componentsModule from './components';
import {
    getAutoInsurancePartner,
    getAutoInsurancePartnerStatus,
    getSmartHomeKitProvider,
    getSmartHomeStarterKitActivationDate,
    hasMortgage,
    hasSmartHomeStarterKit,
    requiresInspection,
    requiresWindMitigationCertification
} from 'common/source/utilities/policyInfoHelper';
import { FlagshipService } from 'services/flagship';
import { CurrentUserService } from 'services/currentUser';
import { checkFeatureFlagAndRedirect } from 'utilities/featureFlags';

import * as _ from 'lodash';

const module = angular.module('checklist-page', [componentsModule.module.name]);

enum SmartHomeProvider {
    Notion = 'notion',
    Simplisafe = 'simplisafe',
    Kangaroo = 'kangaroo',
    ADT = 'adt'
}

interface ChecklistPageController extends angular.IStrictController {
    policyIndex: RoutePolicyIndex;
    policyInfo: CustomerPolicyInfo;
    smartHomeDiscount: number;
    hasMortgage(): boolean;
    requiresInspection(): boolean;
    requiresWindMitigationCertification(): boolean;
    hasChecklistItems(): boolean;
    offeredSmartHomeStarterKit(): boolean;
    showProgressiveStatusInfo(): boolean;
}

module.component('checklistPage', {
    template: template,
    bindings: {
        policyIndex: '<',
        policyInfo: '<',
        smartHomeDiscount: '<'
    },
    controller: function(
        this: ChecklistPageController,
        flagshipService: FlagshipService,
        currentUserService: CurrentUserService,
        $stateParams: PolicyStateParams,
        $window: angular.IWindowService,
        $scope: angular.IScope
    ) {
        const checkFeatureFlag = () => {
            checkFeatureFlagAndRedirect('ReactChecklistPage', flagshipService, $window, currentUserService, $stateParams.policyIndex);
        };

        this.hasMortgage = function() {
            return hasMortgage(this.policyInfo);
        };

        this.$onInit = () => {
            if (flagshipService.getFeatureFlagStatus() === 'FeatureFlagStatus:Ready') {
                checkFeatureFlag();
            } else {
                $scope.$on('FeatureFlagStatus:Ready', () => {
                    checkFeatureFlag();
                });
            }

            const _hasSmartHomeStarterKit = hasSmartHomeStarterKit(this.policyInfo);
            const hasSmartHomeStarterKitActivationDate = _.isString(
                getSmartHomeStarterKitActivationDate(this.policyInfo)
            );

            this.offeredSmartHomeStarterKit = () => {
                // HIP-25455: hide smart home section if smart home kit is ADT,
                // OR policy is in pending_active state
                const isAdt = getSmartHomeKitProvider(this.policyInfo) === SmartHomeProvider.ADT;
                const policyIsNotPendingActive = this.policyInfo.status !== 'pending_active';
                return (
                    policyIsNotPendingActive &&
                    !isAdt &&
                    _hasSmartHomeStarterKit &&
                    !hasSmartHomeStarterKitActivationDate
                );
            };

            this.requiresInspection = () => {
                return requiresInspection(this.policyInfo);
            };

            this.showProgressiveStatusInfo = function() {
                return (
                    getAutoInsurancePartner(this.policyInfo) === 'progressive' &&
                    !!getAutoInsurancePartnerStatus(this.policyInfo)
                );
            };

            this.requiresWindMitigationCertification = () => {
                return requiresWindMitigationCertification(this.policyInfo);
            };

            this.hasChecklistItems = () => {
                return (
                    this.offeredSmartHomeStarterKit() ||
                    this.requiresInspection() ||
                    this.requiresWindMitigationCertification()
                );
            };
        };
    }
});

export { module };
